/** @todo AJAX
import listen from '@mailobj-browser/front/js/history/listen.js'
*/
import contract from '@mailobj-browser/front/js/contracts/contract.js'
import init from './init.js'
import { onError } from '#utilities/js/ea/report.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import one from '@mailobj-browser/front/js/selectors/one.js'

//console.time('tti')

/** @todo AJAX
listen(globalThis)
*/

export default async ({ generics, ...modules }) => {
  const { window } = defaults
  const { document } = window
  
  if (Object.hasOwn(window, 'ea_dedupe_bundle')) {
    return true
  }
  
  if (!one('script[data-current]', document)) {
    const { currentScript } = document
    
    if (currentScript) {
      const { dataset } = currentScript
      
      dataset.current = ''
    }
  }
  
  window.ea_dedupe_bundle = true
  onError.listen(window)
  /** @todo supprimer cette ligne quand tout le JS sera dans le bundle :) */
  window.onerror = null
  
  await init(globalThis, contract({
    ...generics,
    contracts: contract(modules)
  }))

  return true
}
